import React from 'react'
import { Switch, Route } from 'react-router'
import { useUserContext } from "../components/contexts/useUserContext";

import HomePage from '../pages/HomePage'

import MyBookings from '../pages/User/MyBookings'

import LoginPageC from '../pages/LoginPage/clients'
import LoginPageR from '../pages/LoginPage/retailers'
import LoginPageA from '../pages/LoginPage/admin'
import SignUpPage from '../pages/SignUpPage'

import Destination1 from '../pages/SelectDestinations/Destination1'
import Destination2 from '../pages/SelectDestinations/Destination2'
import Destination3 from '../pages/SelectDestinations/Destination3'
import Destination4 from '../pages/SelectDestinations/Destination4'

import RetailerCreate from '../pages/Retailers/Create';

import Contacts from '../pages/Contacts';
import ClientProfile from '../pages/ClientProfile';
import ClientUpdate from '../pages/ClientUpdate';

import RetailerProfile from '../pages/RetailersDashboard/RetailerProfile';
import AdminProfile from '../pages/AdminDashboard/AdminProfile';


import ConfirmationModal from '../pages/ConfirmationModal';

import PaymentPage from '../pages/PaymentMethods'
import PaymentCreditCard from '../pages/PaymentCreditCard'

import PageHowItWork from '../pages/HowItWork';
import BeARetailer from '../pages/BeARetailer';

import TestVoucher from '../pages/TestVoucher';

const Routes = () => {
    const { user } = useUserContext()
    
    return (
        <Switch>
            <Route exact path='/' component={HomePage}/>

            <Route exact path='/contacts' component={Contacts}/>

            <Route exact path='/destination1' component={Destination1}/>
            <Route exact path='/destination2/:categoryId' component={Destination2}/>
            <Route exact path='/destination3/:categoryId/:destinationId' component={Destination3}/>
            <Route exact path='/destination4/:id' component={Destination4}/>

            <Route exact path='/modal/:id' component={ConfirmationModal}/>   

            <Route exact path = '/payment' component={PaymentPage}/>
            <Route exact path = '/credit_card' component={PaymentCreditCard}/>

            <Route exact path='/sign_up/:id?' component={SignUpPage}/>   

            <Route exact path='/retailer/create' component={RetailerCreate}/> 

            <Route exact path='/tutorial' component={PageHowItWork}/>

            <Route exact path='/revendedor/seja' component={BeARetailer}/>

            <Route exact path='/contacts' component={Contacts}/>

            <Route exact path='/voucher' component={TestVoucher}/>
            
            {user && user.type === 'client' ? <Route exact path= '/profile' component = {ClientProfile}/>: 
            user && user.type === 'retailer' ? <Route exact path= '/profile' component = {RetailerProfile}/>:
            user && user.type === 'admin' ? <Route exact path= '/profile' component = {AdminProfile}/> : ''}
            
            {user? <Route exact path= '/profile/edit' component = {ClientUpdate}/>:''} 
            { user
                ?
                    <Route exact path='/user/my-bookings' component={MyBookings}/>
                :
                <>
                    <Route exact path='/login' component={LoginPageC}/>
                    <Route exact path='/login/revendedor' component={LoginPageR}/>
                    <Route exact path='/login/admin' component={LoginPageA}/>
                </>
                
            }
        </Switch>
    )
}

export default Routes
